import { Box, Card, CardContent } from '@mui/material'
import Menu from '@mui/material/Menu'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import GroupIcon from '@mui/icons-material/Group';
import {
  ApartmentOutlined,
  CategoryOutlined,
  DomainOutlined,
  FileCopy,
  Summarize,
  ViewModule,
  Villa
} from '@mui/icons-material'
import { useLocation } from 'react-router-dom'
import React, {useContext, useEffect, useState} from 'react'
import Context from "../../../contexts/Context";
import {getCondoId, getCondoType} from '../../../services/Main/AuthStorage'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CategoryIcon from '@mui/icons-material/Category';
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import {api} from "../../../services/Main/Api";

const SettingsSidebar = () => {
  const { user } = useContext(Context)
  const {perm_expense, perm_rent, perm_bank, is_superuser} = user || {}
  const [enabled, setEnabled] = useState(false);
  const location = useLocation()
  const fetchStatus = async () => {
    try {
      // 🔧 ajuste este endpoint para o que você tiver
      const res = await api.get(`/condo/${getCondoId()}`, { params: { condo_id: getCondoId() } });
      const data = res.data;

      setEnabled(Boolean(res.data?.enabled_sign));
    } catch (e) {
      // se der erro, assume desativado e mostra o paywall
      setEnabled(false);
    } finally {

    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);
  return (
    <>
      <Box>
        <Card>
          <CardContent>
            <List component={'nav'}>

              <ListItemButton
                href={"/configuracoes/contas"}
                selected={location.pathname === "/configuracoes/contas"}
              >
                <ListItemIcon><Villa/></ListItemIcon>
                <ListItemText primary={'Contas'}/>
              </ListItemButton>

              <ListItemButton
                href={"/configuracoes/dadosconta"}
                selected={location.pathname === "/configuracoes/dadosconta"}
              >
                <ListItemIcon><ApartmentOutlined/></ListItemIcon>
                <ListItemText primary={'Dados da Conta'}/>
              </ListItemButton>
              <ListItemButton
                  href={"/configuracoes/usuarios"}
                  selected={location.pathname === "/configuracoes/usuarios"}
              >
                <ListItemIcon><GroupIcon/></ListItemIcon>
                <ListItemText primary={'Usuários'}/>
              </ListItemButton>
              {( getCondoType() === "RENT" || getCondoType() === "BUSINESS") && <ListItemButton
                  href={"/configuracoes/categorias"}
                  selected={location.pathname === "/configuracoes/categorias"}
              >
                <ListItemIcon><CategoryIcon/></ListItemIcon>
                <ListItemText primary={'Categorias'}/>
              </ListItemButton> }
              {perm_bank === true &&
              <ListItemButton
                  href={"/limites"}
                  selected={location.pathname === "/limites"}
              >
                <ListItemIcon><AccountBalanceOutlinedIcon/></ListItemIcon>
                <ListItemText primary={'Limite Bancário'}/>
              </ListItemButton>
            }

              {( getCondoType() === "CONDO") &&
                <ListItemButton
                  href={"/configuracoes/bloco"}
                  selected={location.pathname === "/configuracoes/bloco"}
                >
                  <ListItemIcon><DomainOutlined/></ListItemIcon>
                  <ListItemText primary={'Blocos'}/>
                </ListItemButton>
              }

              {getCondoType() === "CONDO" &&
                <ListItemButton
                  href={"/configuracoes/categorias"}
                  selected={location.pathname === "/configuracoes/categorias"}
                >
                  <ListItemIcon><CategoryOutlined/></ListItemIcon>
                  <ListItemText primary={'Categorias de Despesas'}/>
                </ListItemButton>
              }

              {( getCondoType() === "CONDO") && <ListItemButton
                href={"/configuracoes/relatorios"}
                selected={location.pathname === "/configuracoes/relatorios"}
              >
                <ListItemIcon><Summarize/></ListItemIcon>
                <ListItemText primary={'Relatórios'}/>
              </ListItemButton> }

              {(getCondoType() === "CONDO") && <ListItemButton
                href={"/configuracoes/documentos"}
                selected={location.pathname === "/configuracoes/documentos"}
              >
                <ListItemIcon><FileCopy/></ListItemIcon>
                <ListItemText primary={'Documentos'}/>
              </ListItemButton> }
              {is_superuser &&
              <ListItemButton
                  href={"/configuracoes/whatsapp"}
                  selected={location.pathname === "/configuracoes/whatsapp"}
              >
                <ListItemIcon><WhatsAppIcon/></ListItemIcon>
                <ListItemText primary={'Whatsapp'}/>
              </ListItemButton>
          }

              {( getCondoType() !== "CONDO" && enabled) && <ListItemButton
                  href={"/modelo"}
                  selected={location.pathname === "/modelo"}
              >
                <ListItemIcon><ContentPasteIcon /></ListItemIcon>
                <ListItemText primary={'Assinatura - Modelo'}/>
              </ListItemButton> }

            </List>
          </CardContent>
        </Card>
      </Box>
    </>
  )
}

export default SettingsSidebar
